import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";

import "./Link.css";
import { useRef } from "react";

const Link = ({ index, value, disabled=true, betLocked, handleLinkChange, handleLinkFocus, handleLinkKeyPress, selected, success, error }) => {
  const clClassName =
    (selected ? " selected" : "") +
    (success ? " success" : "") +
    (error ? " error" : "");

  const [displayVal, setDisplayVal] = useState(value);
  const textInput = useRef(null);

  useEffect(()=>{
    setDisplayVal(value);

    if (selected && betLocked) {
      textInput.current.focus();
    }
  }, [value, disabled, selected, betLocked])

  const handleFieldChange = (evt)=>{
    const upperCaseVal = (evt.target.value.length <= value.length && value) || evt.target.value.toUpperCase();

      // console.log('handleFieldChange', evt, evt.keyCode);

    setDisplayVal(upperCaseVal);

    handleLinkChange(index, upperCaseVal);
  }

  const handleFieldFocus = (evt)=>{
    handleLinkFocus(index);
  }

  const handleFieldBlur = (evt)=>{
    // displayValue = value;
  }

  const handleKeyDown = evt => {
    // console.log('handleKeyDown', evt);
    handleLinkKeyPress(evt);
  }

  const containerClassName = (disabled ? ' disabled' : '') +
    (selected ? " selected" : "") +
    (error ? " incorrect" : "") +
    (success ? " correct" : "");

  return (
    <div className={"chain-link-container" + containerClassName}>
      <div className={"chain-link" + clClassName} >
        <input type="text" disabled={disabled} ref={textInput} readOnly={!(selected && betLocked)} onFocus={handleFieldFocus} onKeyDown={handleKeyDown} onChange={handleFieldChange} onBlur={handleFieldBlur} value={displayVal}/>
        <div className="tiles-container">
          {displayVal.split('').map((letter,index)=><div key={value+index}>{letter}</div>)}
          {/* {displayVal.split('').map(letter=><svg viewBox="0 0 11 18"><text x="1" y="15">{letter}</text></svg>)} */}
        </div>
      </div>
    </div>
  );
};

Link.propTypes = {
  value: PropTypes.string.isRequired,
  disabled: PropTypes.bool.isRequired,
  handleLinkChange: PropTypes.func.isRequired,
  // handleLinkFocus: PropTypes.func.isRequired,
  // selected: PropTypes.bool.isRequired,
  // success: PropTypes.bool.isRequired,
  // error: PropTypes.bool.isRequired
};

export default Link;



// WEBPACK FOOTER //
// ./src/components/ChainReactionGame/Link.jsx